/* eslint-disable import/no-anonymous-default-export */
import {
    GET_ALL_VIDEOS,
    SET_FEATURED_VIDEO,
    SET_FEATURED_VIDEOS_FALSE,
    GET_FEATURED_VIDEOS,
    GET_ALL_VIDEOS_ERROR,
    SET_FEATURED_VIDEO_ERROR,
    SET_FEATURED_VIDEOS_FALSE_ERROR,
    GET_FEATURED_VIDEOS_ERROR,
    SEARCH_PUBLISHED_VIDEOS,
    SEARCH_PUBLISHED_VIDEOS_ERROR,
    REMOVE_HOME_PAGE_FEATURED_VIDEO,
    REMOVE_HOME_PAGE_FEATURED_VIDEO_ERROR,
} from "../actions/types";

const initialState = {
    productVideos: [],
    publishedVideos: [],
    featuredVideos: [],
    isLoading: true,
    success: false,
};


export default function (state = initialState, action) {
    const { payload, type } = action;

    switch (type) {
        case GET_ALL_VIDEOS:
            return {
                ...state,
                productVideos: payload,
                isLoading: false,
                success: true,
            };
        case GET_FEATURED_VIDEOS:
            return {
                ...state,
                featuredVideos: payload,
                isLoading: false,
                success: true,
            };
        case SEARCH_PUBLISHED_VIDEOS:
            return {
                ...state,
                publishedVideos: payload,
            };
        case SET_FEATURED_VIDEO:
        case SET_FEATURED_VIDEOS_FALSE:
        case REMOVE_HOME_PAGE_FEATURED_VIDEO:
            return {
                ...state,
                isLoading: false,
                success: true,
            };
        case GET_ALL_VIDEOS_ERROR:
            return {
                ...state,
                productVideos: payload,
                isLoading: false,
                success: false,
            };
        case GET_FEATURED_VIDEOS_ERROR:
            return {
                ...state,
                featuredVideos: payload,
                isLoading: false,
                success: false,
            };
        case SEARCH_PUBLISHED_VIDEOS_ERROR:
            return {
                ...state,
                publishedVideos: [],
            };
        case SET_FEATURED_VIDEO_ERROR:
        case SET_FEATURED_VIDEOS_FALSE_ERROR:
        case REMOVE_HOME_PAGE_FEATURED_VIDEO_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
            };
        default:
            return state;
    }
}
